<template>
  <v-card
    v-if="!hide"
    @click="$emit('click', application.id)"
    class="client application-card elevation-0"
    tile
  >
    <v-layout align-start justify-start row fill-height class="pt-4 pb-3">
      <v-flex xs2 class="text-xs-center">
        <v-layout align-center justify-start row fill-height>
          <v-flex xs3>
            <v-checkbox
              v-if="!isWithdrawn && isManager"
              @click.stop="toggle(application)"
              :input-value="isSelected"
              :color="themes.client.light.tertiary"
              class="pl-2"
            >
            </v-checkbox>
          </v-flex>
          <v-flex>
            <v-progress-circular
              :color="
                application.complete === false
                  ? themes.client.light.warning
                  : themes.client.light.primary
              "
              :value="Number(application.completion)"
              :rotate="-90"
              :size="90"
              :width="5"
            >
              <v-avatar size="80">
                <img
                  v-if="application.profile && application.profile.avatar"
                  :src="application.profile.avatar"
                  v-img-orientation-changer
                />
                <img v-else src="/img/missing/avatars/original.png" />
              </v-avatar>
              <v-avatar
                v-if="featuredQualification"
                style="position: absolute; top: 45px; right: -15px"
                size="40"
              >
                <img
                  v-if="
                    !featuredQualification.institution ||
                    !featuredQualification.institution.logo
                  "
                  src="/img/missing/logos/institutions/original.png"
                />
                <img v-else :src="featuredQualification.institution.logo" />
              </v-avatar>
            </v-progress-circular>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs6>
        <v-card-title
          primary-title
          class="py-0"
          @click="$emit('click', application.id)"
        >
          <div>
            <div class="headline">
              {{ application.profile.firstName }}
              {{ application.profile.lastName }}

              <v-tooltip
                v-if="
                  application.profile && application.profile.disabled == true
                "
                color="grey darken-3"
                class="px-0"
                bottom
              >
                <span slot="activator">
                  <v-icon class="text-vertical-middle"
                    >mdi-wheelchair-accessibility</v-icon
                  >
                </span>
                <span v-if="application.profile.disabilityCategory">
                  {{ categories[application.profile.disabilityCategory] }}
                </span>
                <span v-else>Limiting Disability</span>
              </v-tooltip>

              <v-tooltip
                v-if="application.profile && application.profile.verifiedAt"
                color="grey darken-3"
                class="px-0"
                bottom
              >
                <img
                  slot="activator"
                  class="text-vertical-middle"
                  width="24"
                  height="24"
                  src="/img/verified.png"
                />
                <span>Verified by Leaply</span>
              </v-tooltip>

              <v-tooltip
                v-if="application.applicationsCount > 1"
                color="grey darken-3"
                class="px-0"
                bottom
              >
                <a
                  slot="activator"
                  :href="`/client/applications?search=${application.profile.identification}`"
                  target="_blank"
                  @click.stop=""
                >
                  <v-chip
                    v-if="application.applicationsSucceeded > 0"
                    small
                    class="text-vertical-middle"
                    color="green white--text"
                  >
                    {{ application.applicationsCount }}
                  </v-chip>
                  <v-chip
                    v-else-if="application.applicationsFailed > 0"
                    class="text-vertical-middle"
                    color="red white--text"
                  >
                    {{ application.applicationsCount }}
                  </v-chip>
                  <v-chip v-else small class="text-vertical-middle">
                    {{ application.applicationsCount }}
                  </v-chip>
                </a>
                <span>View other applications</span>
              </v-tooltip>

              <v-tooltip
                v-if="
                  application.eligibility && application.eligibility.referredAt
                "
                color="grey darken-3"
                class="px-0"
                bottom
              >
                <span slot="activator">
                  <v-icon class="text-vertical-middle" color="green"
                    >mdi-account-star</v-icon
                  >
                </span>
                <span>Referred Candidate</span>
              </v-tooltip>

              <v-tooltip
                v-if="application.complete == false"
                :color="themes.client.light.tooltip"
                class="px-0"
                bottom
              >
                <span slot="activator">
                  <v-icon class="text-vertical-middle" color="warning"
                    >mdi-account</v-icon
                  >
                </span>
                <span>Incomplete Profile</span>
              </v-tooltip>

              <v-tooltip
                v-if="!allQuestionnairesCompleted"
                :color="themes.client.light.tooltip"
                class="px-0"
                bottom
              >
                <span slot="activator">
                  <v-icon class="text-vertical-middle" color="warning"
                    >mdi-clipboard-alert</v-icon
                  >
                </span>
                <span>Incomplete Prescreening Questions</span>
              </v-tooltip>

              <v-tooltip
                v-if="
                  application.eligibility &&
                  application.eligibility.eligible === false
                "
                :color="themes.client.light.tooltip"
                class="px-0"
                bottom
              >
                <span slot="activator">
                  <v-icon class="text-vertical-middle" color="error"
                    >mdi-alert-circle</v-icon
                  >
                </span>
                Ineligible
              </v-tooltip>

              <span v-if="application.psychometrics">
                <span
                  v-for="psych in application.psychometrics"
                  :key="`psych-${psych.id}`"
                >
                  <v-tooltip
                    right
                    v-if="
                      psych.show ||
                      psych.provider != 'Odyssey' ||
                      psych.aggregate >= 2
                    "
                  >
                    <v-chip
                      small
                      slot="activator"
                      :color="
                        psych.provider == 'Odyssey'
                          ? recommendationColor(psych)
                          : ''
                      "
                      class="font-weight-bold white--text"
                    >
                      <span
                        v-if="psych.provider == 'Odyssey'"
                        v-text="recommendationText(psych)"
                      ></span>
                      <span v-else>{{ psych.aggregate }}</span>
                    </v-chip>
                    <span v-if="psych.provider == 'Odyssey'">
                      Recommendation for {{ psych.title }} positions:
                      <strong>{{ recommendationText(psych) }}</strong
                      ><br />
                      <span
                        v-for="desc in recommendationDescription(psych)"
                        :key="desc"
                      >
                        <br />
                        {{ desc }}
                      </span>
                    </span>
                    <span v-else>{{ psych.title || "Aggregate" }}</span>
                  </v-tooltip>
                </span>
              </span>

              <v-tooltip
                v-if="unreadMessages.length > 0"
                :color="themes.client.light.tooltip"
                class="px-0"
                bottom
              >
                <v-chip small slot="activator">
                  <v-avatar><v-icon small>mdi-message</v-icon></v-avatar>
                  {{ unreadMessages.length }}
                </v-chip>
                <span>{{ unreadMessages.length }} unread messages</span>
              </v-tooltip>
              <v-tooltip
                v-else-if="messages.length > 0"
                :color="themes.client.light.tooltip"
                class="px-0"
                bottom
              >
                <v-icon
                  small
                  class="text-vertical-middle"
                  slot="activator"
                  :color="themes.client.light.muted"
                  >mdi-message</v-icon
                >
                <span>Messages present</span>
              </v-tooltip>

              <FinancialSurveyChip
                v-if="
                  application.profile.financial &&
                  application.profile.financial.complete
                "
                :profile="application.profile"
                @refresh="refresh"
              />

              <Flag
                v-for="(flag, i) in application.profile.flags"
                :key="`flag-${i}`"
                :value="flag"
                icon
              />
            </div>

            <div v-if="featuredQualification" class="caption grey--text">
              {{ featuredQualification.qualificationTypeName }}
              <span v-if="featuredQualification.specialization">
                in {{ featuredQualification.specialization }}
              </span>
            </div>
            <div
              v-if="
                featuredQualification && featuredQualification.institutionName
              "
              :class="themes.client.light.mutedText"
              class="caption"
            >
              from {{ featuredQualification.institutionName }}
            </div>
            <div class="rating-wrapper my-2">
              <ApplicationRating
                :application="application"
                :readonly="isWithdrawn"
              />
            </div>
          </div>
        </v-card-title>
      </v-flex>
      <v-flex xs5 class="text-xs-right grey--text caption mr-3">
        <span v-if="showMovedAt">
          Moved
          {{
            application.lastApplicationEventAt | inWords({ addSuffix: true })
          }}
        </span>
        <span v-else-if="showViewedAt">
          <span v-if="application.viewedAt">
            Viewed {{ application.viewedAt | inWords({ addSuffix: true }) }}
          </span>
          <v-chip
            v-else
            :color="themes.client.light.successButton"
            style="transform: translateX(5px)"
            small
          >
            New
          </v-chip>
        </span>
        <span v-else>
          Applied {{ application.createdAt | inWords({ addSuffix: true }) }}
        </span>
        <v-layout align-center justify-end class="py-2">
          <ApplicationActivityOverview :application="application" />
          <v-divider
            v-if="
              feedbackRequests.length && application.activitiesOverview.length
            "
            class="pa-2 my-1 mr-2"
            vertical
          />
          <FeedbackRequestsOverview :application-id="application.id" />
        </v-layout>
      </v-flex>
    </v-layout>
    <CandidateQuickActionToolbar
      v-if="!isWithdrawn"
      :candidate="application"
      color="transparent"
      on-hover
    />
  </v-card>
</template>

<script>
// Components
import ApplicationActivityOverview from "@/components/client/applications/ApplicationActivityOverview";
import ApplicationRating from "@/components/client/applications/ApplicationRating";
import CandidateQuickActionToolbar from "@/components/client/application_tracker/CandidateQuickActionToolbar";
import FeedbackRequestsOverview from "@/components/client/feedback_requests/FeedbackRequestsOverview";
import Flag from "@/components/client/flags/Flag";
import FinancialSurveyChip from "@/components/client/candidate/profile/FinancialSurveyChip";

// Helpers
import _ from "lodash";
import { mapGetters } from "vuex";

// Data
import categories from "@/data/disability_categories";

export default {
  props: { application: Object, phase: Object, canEdit: Boolean },

  components: {
    ApplicationActivityOverview,
    ApplicationRating,
    CandidateQuickActionToolbar,
    FeedbackRequestsOverview,
    FinancialSurveyChip,
    Flag,
  },

  data() {
    return {
      hide: false,
      categories: categories.reduce((acc, i) => {
        acc[i.value] = i.text;
        return acc;
      }, {}),
    };
  },

  computed: {
    ...mapGetters({
      chats: "client/chats/all",
    }),
    feedbackRequests() {
      if (!_.get(this, "application.id")) return [];
      return this.$store.getters["client/feedbackRequests/forApplication"](
        this.application.id
      );
    },
    showMovedAt() {
      return (
        _.get(this.$store, "state.client.applications.sort.by") ===
        "lastApplicationEventAt"
      );
    },
    showViewedAt() {
      return (
        _.get(this.$store, "state.client.applications.sort.by") === "viewedAt"
      );
    },
    phaseQuestionnaireIds() {
      if (this.phase && this.phase.behaviors) {
        return this.phase.behaviors.map((b) =>
          b.questionnaireId ? b.questionnaireId : null
        );
      }

      return null;
    },
    allQuestionnairesCompleted() {
      if (!this.phaseQuestionnaireIds || !this.phaseQuestionnaireIds[0])
        return true;
      if (_.get(this.application, "questionnaires.completed")) {
        return (
          this.phaseQuestionnaireIds.filter(
            (id) => this.application.questionnaires.completed.indexOf(id) === -1
          ).length === 0
        );
      }

      return false;
    },
    featuredQualification() {
      if (_.get(this.application, "profile.profileQualification")) {
        // Use featured if available
        return this.application.profile.profileQualification;
      } else if (_.get(this.application, "profile.profileQualifications[0]")) {
        // Otherwise find featured in list
        const qualifications = JSON.parse(
          JSON.stringify(this.application.profile.profileQualifications)
        );
        return qualifications.filter((pq) => pq.featured)[0];
      } else {
        // Otherwise show none
        return null;
      }
    },
    selected() {
      return this.$store.getters["client/applications/selected"];
    },
    isSelected() {
      return this.selected.indexOf(this.application.id) >= 0;
    },
    anySelected() {
      return this.selected[0] !== undefined;
    },
    isWithdrawn() {
      return this.application.status === "Withdrawn";
    },
    isManager() {
      return this.$store.getters["client/opportunities/currentIsManager"]();
    },
    messages() {
      return this.chats.filter((c) => c.application.id === this.application.id);
    },
    unreadMessages() {
      return this.messages.filter(
        (c) => c.senderType === "Candidate" && c.readAt === null
      );
    },
  },

  methods: {
    refresh() {
      return this.$store.dispatch("client/applications/fetch", {
        id: this.application.id,
      });
    },

    toggle(application) {
      if (!this.isSelected) this.select(application.id);
      else this.deselect(application.id);
    },

    select(id) {
      if (this.isWithdrawn) {
        this.$store.dispatch("snackbarShow", "No bulk action available");
        return;
      }
      this.$store.commit("client/applications/select", id);
    },

    deselect(id) {
      this.$store.commit("client/applications/deselect", id);
    },

    recommendationText(psych) {
      switch (psych.aggregate) {
        case 4:
          return "Excellent Fit";
        case 3:
          return "Strong Fit";
        case 2:
          return "Moderate Fit";
        case 1:
          return "Weak Fit";
        case 0:
          return "No Fit";
        default:
          return "";
      }
    },
    recommendationColor(psych) {
      switch (psych.aggregate) {
        case 4:
          return "green darken-1";
        case 3:
          return "light-green darken-1";
        case 2:
          return "lime darken-1";
        case 1:
          return "orange";
        case 0:
          return "red";
        default:
          return "";
      }
    },
    recommendationDescription(psych) {
      switch (psych.aggregate) {
        case 4:
          return [
            "Demonstrates a high skill level to cope with the complexity of the work and a high level of interest and enjoyment for the work.",
            "There is almost no clear risk of employment.",
          ];
        case 3:
          return [
            "Demonstrates a moderate to high skill level to cope with the complexity of the work and a good level of interest and enjoyment for the work.",
            "There is slight or limited risk associated with employment.",
          ];
        case 2:
          return [
            "Demonstrates a moderate to high skill level to cope with the complexity of the work and a moderate level of enjoyment and interest for the work OR",
            "Demonstrates a low to moderate skill level and a good level of enjoyment and interest for the work.",
            "There are some risks associated with employment but still considered a good candidate.",
          ];
        case 1:
          return [
            "Demonstrates a low to moderate skill level to cope with the complexity of the work and moderate level of enjoyment and interest for the work.",
            "There are clear risks associated with employment.",
          ];
        case 0:
          return [
            "Demonstrates a low skill level to cope with the complexity of the work OR",
            "Demonstrates low enjoyment and interest in the work.",
            "There are several risks associated with employment.",
          ];
        default:
          return [];
      }
    },
  },
};
</script>

<style>
.client.application-card div.rating-wrapper > span > fieldset {
  position: relative;
}

.text-vertical-middle {
  vertical-align: middle;
}

.client.application-card {
  cursor: pointer;
  border-bottom: 1px solid #eee;
}
.client.application-card:hover {
  background-color: #fbfbfb;
}

.client.application-card:hover
  .client.application-tracker.quick-action-toolbar
  div.show-on-hover {
  opacity: 1;
}

.client.application-card .v-card__title .v-chip__content .v-avatar {
  margin-left: -8px;
}
</style>
